import DeliveryGroups from 'components/SharedComponents/SplitEDD/DeliveryGroups/DeliveryGroups';

export default DeliveryGroups;
